import { render } from "./PageFooter.vue?vue&type=template&id=6fbaee67&ts=true"
import script from "./PageFooter.vue?vue&type=script&lang=ts"
export * from "./PageFooter.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Work\\Picado\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__